import {
  IAccountStatistics,
  IDailyStatistics,
  IProfitsStatistics,
  IStatisticsProfitsParams
} from '@aqx-core/common/api/statistics';
import { request } from '@aqx-core/common/request';

export default {
  account: (abortSignal?: AbortSignal) =>
    request.get<IAccountStatistics>('/api/statistics/v1/account', { signal: abortSignal }),
  daily: (abortSignal?: AbortSignal) =>
    request.get<IDailyStatistics>('/api/statistics/v1/daily', { signal: abortSignal }),
  profits: (params: IStatisticsProfitsParams, abortSignal?: AbortSignal) =>
    request.get<IProfitsStatistics[]>('/api/statistics/v1/profits', { params, signal: abortSignal })
};
